// extracted by mini-css-extract-plugin
export default {"bug-info":"TiwdYWRXzfC_Vd7TsaVV"};